import React from "react";
import { Trophy } from "lucide-react";

/**
 * Single-elimination bracket viewer.
 * bracket = { rounds: [[{a,b,winner,score_a,score_b,id}, ...], ...] }
 * playersById = { [user_id]: {first_name, last_name} }
 */
function Slot({ pid, isWinner, playersById }) {
  const u = pid ? playersById[pid] : null;
  const label = pid ? (u ? `${u.first_name || ""} ${u.last_name || ""}`.trim() || "—" : "Player") : "BYE";
  return (
    <div className={`px-3 py-2 text-sm ${isWinner ? "text-[#00E676] font-bold" : "text-zinc-300"}`}>{label}</div>
  );
}

export default function Bracket({ bracket, playersById = {}, onRecord }) {
  if (!bracket || !bracket.rounds || !bracket.rounds.length) {
    return <div className="text-zinc-500 text-sm">No bracket generated yet.</div>;
  }
  return (
    <div className="overflow-x-auto" data-testid="bracket-view">
      <div className="flex gap-6 min-w-max">
        {bracket.rounds.map((round, ri) => (
          <div key={`round-${ri}`} className="flex flex-col justify-around gap-3 min-w-[220px]">
            <div className="text-xs uppercase tracking-wider text-zinc-500 mb-1">
              {ri === bracket.rounds.length - 1 ? <span className="text-[#00E676] flex items-center gap-1"><Trophy size={12} /> Final</span> : `Round ${ri + 1}`}
            </div>
            {round.map((m, mi) => (
              <div key={m.id} className="pp-card p-1" data-testid={`bracket-r${ri}-m${mi}`}>
                <Slot pid={m.a} isWinner={m.winner && m.winner === m.a} playersById={playersById} />
                <div className="border-t border-white/5" />
                <Slot pid={m.b} isWinner={m.winner && m.winner === m.b} playersById={playersById} />
                <div className="px-3 py-1 flex items-center justify-between text-xs text-zinc-500">
                  <span>{m.score_a != null ? `${m.score_a}–${m.score_b}` : ""}</span>
                  {onRecord && !m.winner && m.a && m.b ? (
                    <button data-testid={`bracket-record-r${ri}-m${mi}`} onClick={() => onRecord(ri, mi, m)} className="text-[#00E676] hover:underline">Record</button>
                  ) : null}
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
